import axiosInstance from 'api/axiosInstance';
import { URL_GET_COMPANIES } from 'constants/urls';

/**
 * @async
 * @function getCompanies
 * @returns { Promise<Array> } Data
 */
async function getCompanies() {
	const {
		data: { Data },
	} = await axiosInstance.get(URL_GET_COMPANIES);
	return Data;
}

export default getCompanies;
